import { useEffect, useState } from 'react'
import { Animated, Platform, StyleSheet, View } from 'react-native'
import PropTypes from 'prop-types'
import { useCarouselSavedIndex } from '../BaseCarousel/CarouselContext'

const fadeDelayDefault = 8000
const fadeDuration = 750

const FadingView = ({ isActive, children }) => {
  const [opacityAnim] = useState(new Animated.Value(isActive ? 1 : 0))

  useEffect(() => {
    Animated.timing(opacityAnim, {
      toValue: isActive ? 1 : 0,
      duration: fadeDuration,
      useNativeDriver: Platform.OS !== 'web',
    }).start()
  }, [isActive])

  return (
    <Animated.View
      pointerEvents={isActive ? 'auto' : 'none'}
      style={[
        StyleSheet.absoluteFill,
        {
          opacity: opacityAnim,
          pointerEvents: isActive ? 'auto' : 'none',
        },
      ]}
    >
      {children}
    </Animated.View>
  )
}

export const FadingCarousel = ({
  fadeDelay = fadeDelayDefault,
  scrollPositionSlug,
  initialSlide = 0,
  autoScroll = true,
  items,
  children,
  ...props
}) => {
  const { initialIndex, saveIndex } = useCarouselSavedIndex(scrollPositionSlug, initialSlide)

  const [activeIndex, setActiveIndex] = useState(initialIndex)

  useEffect(() => {
    if (autoScroll) {
      const timeout = setTimeout(() => {
        const newIndex = (activeIndex + 1) % items.length
        saveIndex(newIndex)
        setActiveIndex(newIndex)
      }, fadeDelay + fadeDuration)
      return () => clearTimeout(timeout)
    }
  }, [activeIndex, setActiveIndex, saveIndex, items.length, fadeDelay, autoScroll])

  return (
    <View {...props}>
      {items.map((item, index) => (
        <FadingView key={index} isActive={index === activeIndex}>
          {children(item, index)}
        </FadingView>
      ))}
    </View>
  )
}

FadingCarousel.propTypes = {
  scrollPositionSlug: PropTypes.string.isRequired,
}
